<template>
  <div>
    <Carousel />
    <AboutBrief />
    <ProjectList :projects="projects" :showMore="true" />
    <PartnerWall :partners="partners" />
  </div>
</template>

<script>
import Carousel from '../components/Carousel.vue';
import AboutBrief from '../components/AboutBrief.vue';
import ProjectList from '../components/ProjectList.vue';
import PartnerWall from '../components/PartnerWall.vue';

export default {
  name: 'HomeView',
  components: {
    Carousel,
    AboutBrief,
    ProjectList,
    PartnerWall
  },
  data() {
    return {
      projects: [],
      partners: []
    };
  }
};
</script>

<style scoped>
h1 {
  color: #409EFF;
  margin: 0;
}
</style>